/* Keep feedback tied to the action the shopper just took. */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.pd-ribbon-toggle');
  if (!toggle) return;
  const paused = toggle.getAttribute('aria-pressed') !== 'true';
  toggle.setAttribute('aria-pressed', String(paused));
  toggle.setAttribute('aria-label', paused ? 'Play sale ribbon' : 'Pause sale ribbon');
  toggle.textContent = paused ? '▶' : 'Ⅱ';
  toggle.closest('.announcement-bar').classList.toggle('pd-ribbon-paused', paused);
});

document.addEventListener('click', (event) => {
  const filter = event.target.closest('[data-pd-filter]');
  if (filter) {
    const browse = filter.closest('[data-pd-browse]');
    const grid = document.getElementById(filter.getAttribute('aria-controls'));
    if (!grid) return;
    let count = 0;
    grid.querySelectorAll('[data-pd-kind]').forEach(card => {
      const show = filter.dataset.pdFilter === 'all' || card.dataset.pdKind === filter.dataset.pdFilter;
      card.hidden = !show;
      if (show) count++;
    });
    browse.querySelectorAll('[data-pd-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
    browse.querySelector('[role=status]').textContent = `${count} ${filter.dataset.pdFilter === 'all' ? 'products' : filter.dataset.pdFilter}`;
  }
  const unit = event.target.closest('[data-pd-unit]');
  if (unit) {
    const guide = unit.closest('.ps-size-guide');
    const inches = unit.dataset.pdUnit === 'in';
    guide.querySelectorAll('tbody td').forEach(cell => {
      if (!cell.dataset.cm) cell.dataset.cm = cell.textContent.trim();
      cell.textContent = inches ? cell.dataset.cm.replace(/\d+(?:\.\d+)?/g, n => (Number(n) / 2.54).toFixed(1)) : cell.dataset.cm;
    });
    guide.querySelector('caption').textContent = inches ? 'Measurements in inches (approximate)' : 'Measurements in centimeters';
    guide.querySelectorAll('[data-pd-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
  }
});
